<div class="voucher" #pdfTemplate>
    <style>
        .voucher-body {
            font-family: 'Inter', Arial, sans-serif;
            color: #535353 !important;
            background-color: white;
            font-size: 12px !important;
        }

        .info-cobro-detalle .label {
            font-weight: bold;
            display: inline-block;
            width: 100px;
        }

        .info-items {
            display: flex;
            flex-direction: column;
            border-radius: 8px;
        }

        .info-items-detail {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            border-top: 1px solid #BEBEBE;
        }

        .text-bold {
            font-weight: bold;
        }

        .text-center {
            text-align: center;
        }

        .border-r {
            border-right: 1px solid #BEBEBE;
        }

        .merchantLogo{
            width: 120px;
        }
    </style>
    <div class="voucher-body">
        <div class="header">
            <div class="header-info">
                <p>{{ fechaSolicitud() }}</p>
                <section class="header-merchant-info">
                    <p><b>{{merchantName}}</b></p>
                    <p><b>RUT {{merchantIdentification}}</b></p>
                    <p><b>{{getMerchantAddress()}}</b></p>
                </section>
            </div>
        </div>
        <div class="info-cobro" style="margin-top: 24px">
            <p><b>Estimado cliente,</b></p>
            <p style="margin-top: 6px">A continuación, se presentan los antecedentes de su cobro:</p>
            <section class="info-cobro-detalle" style="margin-top: 12px">
                <div>
                    <span class="label">ID de cobro</span>
                    <span>{{charge.order_number}}</span>
                </div>
                <div style="margin-top: 6px">
                    <span class="label">Fecha/Hora</span>
                    <span>{{ charge.date | date:'dd/MM/yyyy HH:mm' }}</span>
                </div>
                <div style="margin-top: 6px">
                    <span class="label">Tipo de cobro</span>
                    <span>{{ charge.type }}</span>
                </div>
                <div style="margin-top: 6px">
                    <span class="label">Estado</span>
                    <span>{{ charge.status }}</span>
                </div>
            </section>
        </div>
        <div class="info-items" style="margin-top: 24px; border: 1px solid #BEBEBE;">
            <div class="text-bold" style="padding-bottom: 12px; padding-left: 24px;">
                Desglose de ítems
            </div>
            <div>
                <section class="info-items-detail text-bold text-center">
                    <span class="border-r" style="padding-bottom: 12px;">
                        Documento de referencia
                    </span>
                    <span class="border-r">Descripción</span>
                    <span>Monto</span>
                </section>

                @for(item of charge.items; track $index ) {
                    <div class="info-items-detail text-center" s>
                        <span class="border-r" style="padding-bottom: 12px;">
                            <span class="mr-1">{{ item.documentType | docTypeLabel }}</span>
                            <span>{{ item.documentNumber }}</span>
                        </span>
                        <span class="border-r">
                            {{ item.description }}
                        </span>
                        <span>
                            {{ item.amount | currencyClp }}
                        </span>
                    </div>
                }

                <div class="info-items-detail text-bold text-center">
                    <span ></span>
                    <span style="padding-bottom: 12px;">Total del cobro</span>
                    <span>
                        {{ charge.amount | currencyClp }}
                    </span>
                </div>
            </div>
        </div>
        <div class="info-cobro" style="margin-top: 24px;">
            <p>
                Este comprobante confirma que el pago se realizó con éxito. Si necesitas más información o documentos relacionados, contáctanos.
            </p>
            <p style="margin-top: 24px">
                Atentamente,
            </p>
            <p>
                <b>{{merchantName}}</b>
            </p>
        </div>
    </div>
    <!-- para que no corte el texto al exportar -->
    <div style="height: 40px;"></div>
</div>
